import { atomWithStorage } from 'jotai/utils';
import type { ExternalAgentId } from 'src/components/ExternalAgentMenu/externalAgents';

/** Which external agent the header's "Open in …" button opens. Browser-local,
 *  like the other AI Agent preferences in chatPreferences.ts. */
export const externalAgentAtom = atomWithStorage<ExternalAgentId>(
  'fs.externalAgent.default',
  'claude',
);
